const common = {
  'Common': '通用',

  'Back': '返回',
  'Cancel': '取消',

  'Select All': '全选',
  'Select Reverse': '反选',

  'All': '全部',

  'Rare': '稀有度',
  'Star 3': ' ★3 ',
  'Star 4': ' ★4 ',
  'Star 5': ' ★5 ',
  'Rares': {
    2: ' ★3 ',
    3: ' ★4 ',
    4: ' ★5 ',
  },

  'Class': '职业',
  'Fighter': '战士',
  'Magician': '魔法使',
  'Priest': '僧侣',
  'Knight': '骑士',
  'Alchemist': '炼金术士',
  'Classes': {
    '-1': '默认',
    0: '战士',
    1: '魔法使',
    2: '僧侣',
    3: '骑士',
    4: '炼金术士',
  },

  'Element': '元素',
  'Fire': '火',
  'Water': '水',
  'Earth': '土',
  'Wind': '风',
  'Moon': '月',
  'Sun': '阳',
  'Elements': {
    '-1': '默认',
    0: '火',
    1: '水',
    2: '土',
    3: '风',
    4: '月',
    5: '阳',
  },

  'Abnormal': '异常',
  'Abnormals': {
    'All': '全部异常',
    0: '混乱',
    1: '束缚',
    2: '空腹',
    3: '虚弱',
    4: '睡眠',
    5: '不幸',
    6: '沉默',
    7: '孤立',
  },

  'Status': '状态',
  'Statuses': {
    'All': '全部状态',
    0: ' ATK ',
    1: ' MAT ',
    2: ' DEF ',
    3: ' MDF ',
    4: ' SPD ',
    5: ' LUK ',
  },

  'Default': '默认',

  'comma': '，',
  'dot': '。',
  'divider': '、',

  'Condition': '条件',
  'Probability': '概率',
  'Filter': '筛选',
  'Input': {
    'Filter': '输入条件..',
  },
  'Sort': '排序',
  'Reverse': '倒序',
  'Japanese': '日语',
};

const home = {
  'Home': '主页',
  'KiraFan.Moe': 'KiraFan.Moe',
  'KiraFan Wiki': 'Kirara Fantasia 解析 Wiki',
  'Day Count': '今天是 Kirara Fantasia 开服以来的第 {0} 日',

  'Version': '版本',
  'Version Info': '该版本解析 Wiki 数据由 Media 抄自圣典',

  'Events': '活动',
  'Summon': '召唤',
  'Summon 10 Times': '10 回召唤',
};

const chatacter = {
  'Characters': '角色卡',
  'Character': '角色卡',
  'No Character': '无角色',

  'Obtainability': '获取方法',
  'Normal': '普通',
  'Distributed Weaken': '配布-',
  'Distributed': '配布',
  'Period Limited': '期间限定',
  'Year': '年',

  'Level': '等级',
  'Arousal': '觉醒',
  'Facilities': '设施',
  'Friendship': '好感度',
  'Title Facility': '作品设施',
  'Class Facility': '职业训练所',
  'Orb': '宝珠',

  'Illust': '卡图',
  'Weapons': '武器',
  'Flavor Text': '召唤台词',
  'Creamate Commu Text': '克里耶梅特交流台词',
  'Achievements': '称号',

  'Related Characters': '相关角色卡',
  'Same Rare Class Element': '同为{rare}{element}元素的{class}',
  'Same Event': '历年的期间限定活动中登场',
  'Same Named': '{name}的其他卡片',
};

const named = {
  'Names': '角色',
  'Named': '角色',
  'No Named': '无角色',

  'Profile': '角色简介',
  'Nick Name': '昵称',
  'Full Name': '全名',
  'Gift Type': '土产种类',
  'Gift Types': {
    1000: '强化素材',
    2000: '武器强化素材',
    3000: '金币',
  },

  'Voice': '语音',
  'CV': ' CV ',
  'Character Voice Type': {
    0: '系统',
    1: '剧情',
    2: '小镇',
    3: '战斗',
  },
  'Character Voice Category': {
    '000': '游戏标题',
    '001': '启动时问候・通用',
    '002': '启动时问候・早',
    '003': '启动时问候・晚',
    '006': '强化',
    '008': '进化',
    '009': '训练出发',
    '010': '训练完成',
    '012': '任务',
    '013': '任务完成',

    '400': '关卡出发',
    '401': '战斗开始',
    '403': '攻击 1',
    '405': '攻击 2',
    '406': '攻击技能',
    '409': '辅助技能',
    '411': '应援技能',
    '412': '珍藏发动',
    '413': '伤害',
    '415': '异常',
    '416': '战斗不能',
    '417': '战斗胜利',
    '419': '战斗败北',
    '420': '触摸语音',

    'Room1': '小屋会话 1',
    'Room2': '小屋会话 2',
    'RoomAction': '小屋动作',
    'Town1': '小镇访问 1',
    'Town2': '小镇访问 2',
    'TownAction': '小镇动作',
    'Home': '主画面会话',

    'Default': '默认',
  },

  'Talent': '天赋',
  'Adv Standpic': '剧情立绘',

  'Related Names': '相关角色',
  'Same Title': '来自作品『{title}』',
  'Same CV': '{name}配音的角色',
  'Cross Adv': '交叉剧情中出现的人物',

  'Original Character': '原创角色',
  'Illustrator': '画师',
};

const skill = {
  'Skills': '技能',
  'Skill': '技能',
  'Skill Name': '技能名',
  'Load': '硬直',
  'Recast': '冷却',
  'Charge': '充能',
  'Level': '等级',
  'Stun Gauge': '眩晕条',

  'Passive Skill': '被动技能',
  'No Skill': '无技能',
  'No Passive Skill': '无被动技能',

  'Skill Selector': '技能选择器',

  'Skill Target': '目标',
  'Skill Targets': {
    0: '自身',
    1: '敌方单体',
    2: '敌方全体',
    3: '己方单体',
    4: '己方全体',
  },

  'Skill Damage Types': {
    0: '物理',
    1: '魔法',
  },

  'Skill Signs': {
    '-1': '降低',
    0: '变化',
    1: '提升',
  },

  'Skill Verbs': {
    '-1': '下降',
    0: '变化',
    1: '上升',
  },

  'Skill Turn Types': {
    0: '轮',
    1: '回合',
  },

  'Skill Type': '技能种类',
  'Skill Types': {
    0: '攻击',
    1: '回复',
    2: '状态变化',
    3: '状态变化清除',
    4: '异常',
    5: '异常回复',
    6: '异常无效化',
    7: '异常抵抗率',
    8: '元素耐性',
    9: '元素变化',
    10: '克制元素加成',
    11: '下次攻击提升',
    12: '下次攻击暴击',
    13: '屏障',
    14: '冷却变化',
    15: '珍藏条变化',
    16: '珍藏条倍率变化',
    17: '行动值变化',
    18: '仇恨变化',
    19: '充能变化',
    20: '珍藏连携系数变化',
    21: '技能卡',
    22: '眩晕回复',
    23: '再生',
    24: '无',
    25: '技能硬直下降',
    26: '暴击伤害变化',
    27: '自身伤害',
    28: '随机状态变化',
    29: '被伤害时珍藏条上升',
    30: '状态变化无效化',
  },

  'Skill Detail': '说明',
  'Skill Details': {
    0: '对{target}造成{amount}{damageType}伤害 ({power})',
    1: '对{target}{amount}回复 ({power})',
    2: '{target}的{status}在 {turn} {turnType}内{amount}{sign} ({power})',
    3: '对{target}清除{status}{sign}',
    4: '对{target}{amount}赋予{abnormal} ({power})',
    5: '对{target}解除{abnormal}',
    6: '{target}在 {turn} {turnType}内异常免疫',
    7: '{target}的异常抵抗率在 {turn} {turnType}内{sign} ({power})',
    8: '{target}的{element}耐性在 {turn} {turnType}内{amount}{sign} ({power})',
    9: '{target}变为{element}元素',
    10: '{target}的有利元素伤害在 {turn} {turnType}内提升 ({power})',
    11: '{target}的下一次{damageType}攻击{amount}提升 ({power})',
    12: '{target}的下一次攻击必定暴击',
    13: '对{target}赋予 {turn} 层{amount}抵挡攻击的屏障 ({power})',
    14: '{target}的技能冷却{amount}{verb} ({power})',
    15: '珍藏条{amount}{verb} ({power})',
    16: 'きららジャンプゲージ倍率変化',
    17: '行動順変化',
    18: '{target}的仇恨在 {turn} {turnType}内{amount}{sign} ({power})',
    19: '{target}的充能数{verb} ({power})',
    20: 'チェイン倍率変化',
    21: '设置 {turn} 枚技能卡：「{extra}」',
    22: 'スタン回復',
    23: '对{target}赋予 {turn} 回合再生 ({power})',
    24: '什么都不做',
    25: '对{target}赋予 {turn} {turnType}高速咏唱 (-{power}) <small><br>技能硬直下降</small>',
    26: '{target}的暴击伤害在 {turn} {turnType}内{amount}{sign} ({power})',
    27: '{target}的 HP 减少 ({power})',
    28: '{target}的随机一项状态在 {turn} {turnType}内{amount}{sign}',
    29: '对{target}赋予 {turn} {turnType}隐忍 ({power}) <small><br>每当受到伤害时珍藏充能增加</small>',
    30: '{target}在 {turn} {turnType}内状态下降免疫',
  },

  'Skill Amount': '量',
  'Skill Amount Sign': '{amount}{sign}',
  'Skill Amounts': {
    0: { 0: '特殊', 1: '少量', 2: '中量', '3-': '较大', 3: '大量', 4: '特大', 5: '超特大' },
    1: { 1: '小', 2: '中', 3: '大', 4: '特大' },
    2: { 1: '小幅', 2: '中幅', 3: '大幅', 4: '特大' },
    4: { 1: '低概率', 2: '中概率', 3: '高概率', 4: '' },
    8: { 1: '小幅', 2: '中幅', 3: '大幅' },
    11: { 1: '小幅', 2: '中幅', 3: '大幅', 4: '特大' },
    13: { 1: '小幅', 2: '中幅', 3: '大幅', 4: '完全' },
    14: { 1: '小幅', 2: '中幅', 3: '大幅' },
    15: { 1: '小幅', 2: '中幅', 3: '大幅' },
    18: { 1: '小幅', 2: '中幅', 3: '大幅' },
    26: { 1: '小幅', 2: '中幅', 3: '大幅' },
  },

  'Skill Powers': {
    0: {
      0: '{power}%',
      1: '{power}%、异常中目标 {power2}%',
      2: '{power}% 最大 HP',
      3: '{power}% 当前 HP',
      4: '{power} 点',
      5: '{powerA}%、{powerB}%、{powerC}%',
      100: '{power}%、{abnormal}中目标 {power2}%',
    },
    27: {
      0: '{power}% 最大 HP',
      1: '{power}% 当前 HP',
      2: '{power} 点',
    },
    28: {
      'Power': '{prob}%: {power}',
      'Status Change': '{status}{amount}{sign} ({power})',
    }
  },

  'Passive Triggers': {
    0: '',
    1: '每当自身收到攻击时',
    2: '每当自身打倒敌人时',
  },

  'Passive Details': {
    0: '自身的{status}{amount}{sign} ({power})',
    1: '自身的仇恨{amount}{sign} ({power})',
    2: '自身异常免疫',
    3: '自身眩晕免疫',
    4: '自身的攻击的眩晕量提升 ({power}) <br><small>收到攻击的敌人的眩晕槽上升量提升</small>',
    5: '珍藏条{amount}{verb} ({power})',
    6: '自身的珍藏条系数{sign} ({power}) <br><small>行动获得的珍藏条上升量变化</small>',
    7: '自身的暴击伤害{amount}{sign} ({power})',
    8: '自身的技能变更',
    9: '自身的回复技能可以超越最大 HP ({power})',
    10: '依照给予敌人的伤害对自身回复',
    11: '自身可以复活 ({power}) <br><small>首次受到致死伤害时回复</small>',
    12: '自身的技能卡的发动回数{verb} ({power})',
    13: '自身的{status}根据 HP 进行变化',
    14: '{target}的{status}在 {turn} {turnType}内{amount}{sign} ({power})',
  },

  'Passive Powers': {
    10: {
      0: '通常攻击',
      1: '职业技能',
      2: '武器技能',
      3: '珍藏技能',
    },
    11: {
      0: '{0}% HP',
      1: '{0} 点',
    },
    13: {
      'Status Change': '{status}{amount}{sign} ({power})',
    }
  }
};

const item = {
  'Items': '物品',
  'Item': '物品',
  'No Item': '无物品',

  'Type': '种类',
  'Item Type': {
    0: '强化素材',
    1: '进化素材',
    2: '限界突破素材',
    3: '武器素材',
    4: '其他',
    10: '活动素材',
  },

  'Category': '分类',
  'Item Category Event': '活动「{event}」中的物品',
  'Item Category': {
    0: '小种',
    1: '种',
    2: '大种',
    3: '新芽',
    4: '作品限定星华',

    100: '小进化珠',
    101: '进化珠',
    102: '大进化珠',
    103: '特大进化珠',
    104: '超进化珠',
    112: '青铜雕像',
    113: '白银雕像',
    114: '黄金雕像',
    124: '作品限定超进化珠',

    202: '蕾',
    203: '果实',
    204: '星结晶',
    214: '作品限定星结晶',

    300: '符',
    301: '纹章',
    311: '第一章武器素材',
    312: '第二章武器素材',
    313: '第三章武器素材',
    314: '第四章武器素材',
    315: '第五章武器素材',
    316: '第六章武器素材',
    317: '第七章武器素材',
    318: '第八章武器素材',

    404: '特殊',
    405: '召唤券',
    406: '交换物品',
    407: '体力回复物品',
    408: 'Etoilium',
    409: '概率提升钥匙链',
    410: '技能提升粉末',
  },

  'From Event': '来源活动',
  'Experience': '经验值',
  'Sale Amount': '卖出单价',
};

const weapon = {
  'Weapons': '武器',
  'Weapon': '武器',
  'No Weapon': '无武器',

  'Level': '等级',
  'Evolution': '进化',
  'Upgrade Bonus Material Items': '强化加成素材',
  'Recipe': '作成必要素材',
  'Evolution Recipe': '进化必要素材',

  'Equipable Character': '可装备角色',
  'Star 5 Special Weapon': '★5{0}专用{1}',
};

const master = {
  'Master': '琪拉拉',
  'Stamina': '体力',
  'Battle Party Cost': '队伍 Cost',
  'Friend Limit': '好友数',
  'Support Limit': '支援数',
  'Weapon Limit': '武器数',
  'Training Slot Num': '训练数',
  'Master Skills': '琪拉拉技能',
  'Master Orb': '琪拉拉宝珠',
  'Master Skill Type': '{class}宝珠',
};

const quest = {
  'Quest Libraries': '关卡章节',
  'Quest Library': '关卡章节',
  'Quests': '关卡',
  'Quest': '关卡',
  'Section': '第 {0} 节',
  'No Quest': '无关卡',

  'Quest Library Categories': {
    0: '主线关卡',
    1: '活动关卡',
    2: '作家关卡',
    3: '日常关卡',
    4: '强敌挑战关卡',
    5: '专武纪念关卡',
    6: '作品工艺关卡',
  },

  'Event Information': '活动情报',
  'Event Abstract': '活动简介',
  'Event Bonus': '活动加成',

  'Enemies': '敌人',
  'Drops': '掉落',

  'User Exp': '琪拉拉经验值',
  'Character Exp': '角色经验值',
  'Friendship Exp': '好感度',
};

const scenario = {
  'Scenario Libraries': '剧情章节',
  'Scenario Library': '剧情章节',
  'Scenarios': '剧情',
  'Scenario': '剧情',
  'No Scenario': '无剧情',

  'Scenario Library Categories': {
    5: '角色剧情',
    1: '主线剧情',
    2: '活动剧情',
    3: '作家剧情',
  },
  'Character Scenario': '角色剧情',
  'Cross Scenario': '交叉剧情',
  'Memorial Scenario': '专武纪念剧情',

  'Standpic': '立绘',
  'Pose': '姿势',
  'Face': '表情',
};

const title = {
  'Titles': '作品',
  'Title': '作品',
  'No Title': '无作品',

  'Number of ★5': '★5 数',
  'Number of Characters': '角色卡数',

  'Non-Player Characters': 'NPC 角色',
  'Event Characters': '活动角色',
};

const enemy = {
  'Enemy': '敌人',
  'No Enemy': '无敌人',
  'Resist Abnormals': '异常免疫',
  'AI ID': ' AI ID ',
  'Charge Max': '充能数',
  'Full Charge': '满充能',
  'Stun Coef': '眩晕系数',

  'AI Conditions': {
    num: '此条件最多触发 {num} 次',
    0: '自身的 HP 在 {min}% ~ {max}% 的范围内',
    1: {
      0: [
        '敌人队伍中存在{abnormal}的人数 {op} {num}',
        '敌人队伍中不存在{abnormal}的人数 {op} {num}',
      ],
      1: [
        '其他敌人中存在{abnormal}的人数 {op} {num}',
        '其他敌人中不存在{abnormal}的人数 {op} {num}',
      ],
      2: [
        '自身存在{abnormal}',
        '自身不存在{abnormal}',
      ],
    },
    2: {
      0: [
        '敌人队伍中存在{statusChange}的人数 {op} {num}',
        '敌人队伍中不存在{statusChange}的人数 {op} {num}',
      ],
      1: [
        '其他敌人中存在{statusChange}的人数 {op} {num}',
        '其他敌人中不存在{statusChange}的人数 {op} {num}',
      ],
      2: [
        '自身存在{statusChange}',
        '自身不存在{statusChange}',
      ],
    },
    3: '自身的充能数 {op} {num}',
    21: '敌人队伍中的人数 {op} {num}',
    42: '玩家队伍中的人数 {op} {num}',
    43: [
      '玩家队伍中存在{abnormal}的人数 {op} {num}',
      '玩家队伍中不存在{abnormal}的人数 {op} {num}',
    ],
    44: '每当玩家队伍使用通常攻击达到 {num} 次',
    45: '每当玩家队伍使用技能达到 {num} 次',
    46: '每当玩家队伍使用珍藏达到 {num} 次',
    47: '每当玩家队伍交换角色达到 {num} 次',
    48: '玩家队伍中{extra}{class}的人数 {op} {num}',
    49: '玩家队伍中存在{statusChange}的人数 {op} {num}',
    68: {
      0: '自身不存在 Flag {num}',
      1: '自身存在 Flag {num}',
    },
  },

  'AI Condition Status Changes': {
    0: ' ATK 提升',
    1: ' MAT 提升',
    2: ' DEF 提升',
    3: ' MDF 提升',
    4: ' SPD 提升',
    5: ' LUK 提升',
    6: ' ATK 降低',
    7: ' MAT 降低',
    8: ' DEF 降低',
    9: ' MDF 降低',
    10: ' SPD 降低',
    11: ' LUK 降低',
    12: '状态提升',
    13: '状态降低',
  },

  'AI Condition Ops': {
    0: '≥',
    1: '≤',
    2: '=',
  },

  'AI Flags': {
    0: '自身移除 Flag {num}',
    1: '自身设置 Flag {num}',
  },


  'AI Single Condition': '目标选择：{target}优先级{sign} ({power})',
  'AI Single Condition Signs': {
    '-1': '低',
    1: '高',
  },
  'AI Single Conditions': {
    0: 'HP < 20% 的目标',
    1: '{element}元素的目标',
    2: '{class}',
    3: [
      '存在{abnormal}的目标',
      '不存在{abnormal}的目标',
    ],
    4: '克制元素',
    5: '存在{statusChange}的目标',
    6: '自身',
  },
};

const roomObject = {
  'Room Objects': '家具',
  'Room Object': '家具',

  'Change Night': '夜间模式',
  'Non-Reverse': '反转不可',

  'Size': '尺寸',
  'Buy Amount': '购入单价',
  'Sell Amount': '卖出单价',
  'Max Num': '最大所持数',

  'Search Points': '角色互动位置',
  'Search Points Hint': '角色互动位置指角色在家具周边可以触发动作或者谈话的地点。',
  'Character Action': '角色动作',
  'No Character Action': '无角色动作',
  'Character Tweets': '角色会话',
  'No Character Tweets': '无角色会话',

  'Room Object Action Conditions': {
    0: '任意角色',
    1: '角色卡限定',
    2: '角色限定',
    3: '作品限定',
  },

  'Room Object Categories': {
    0: '桌子',
    1: '椅子',
    2: '收纳',
    3: '寝具',
    4: '家电',
    5: '杂货',
    6: '玩具',
    7: '墙饰',
    8: '地毯',
    9: '屏风',
    10: '地板',
    11: '墙壁',
    12: '背景',
  },
};

const townObject = {
  'Town Objects': '小镇建筑',
  'Town Object': '小镇建筑',

  'Schedule': '日程',
  'Text': '文字',
};

const help = {
  'Page Help': '页面帮助',
  'Page Helps': {
    'Room Object': `
            <p>家具数据的解析由コースケ协助完成。若有关于家具的问题或建议，欢迎与我们联系。</p>
        `,
    'Enemy AI Pattern': `
            <p>敌人的 AI 行动模式是按照页面展示的顺序，从上到下依次判断条件，选择第一个符合全部条件的来执行。每次敌人行动时都会按照这个方式来确定释放的技能。</p>
            <p>当一个条件下有多个技能可以选择时，按照概率随机选择一个技能进行释放。处于混乱中的敌人会从混乱技能列表中等概率随机挑选一个技能进行释放。</p>
            <p>条件中的 Flag 可以理解为条件变量，敌人在释放特定技能后会变更 Flag 的真值，从而实现复杂的行动模式。不同敌人的 Flag 是相互独立的。</p>
            <p>技能中的目标仇恨提升或降低是属于敌人的 AI 行动模式中的一部分，并不属于技能本身的内容，仅对本次技能释放的对象选择造成影响。具体请参阅<a href="https://calc.kirafan.moe/#/document/18", target="_blank">仇恨值的计算方法</a>。</p>
            <p>AI 行动模式解析可能不完全准确，若发现不符合此页面描述的情况，请录制视频反馈给 Circle Lin。</p>
        `,
  },
};

const navigation = {
  'Navigation': '导航',
  'Collection': '收藏',

  'Battle': '战斗',
  'Items': '物品',
  'Library': '图书馆',
  'Tools': '工具',
  'Links': '链接',
  'Others': '其他',
  'Applications': 'Kirara Fantasia 解析应用',
  'External Links': '外部链接',

  'Calculator': { Title: '计算器', Subtitle: '数值计算和相关计算方法的手册' },
  'Assets': { Title: '素材浏览器', Subtitle: '下载卡图、立绘和语音' },
  'Card Maker': { Title: '卡片制作', Subtitle: '卡片制作工具' },
  'Yarudesu': { Title: 'やるデース！速報', Subtitle: '日语 Kirara Fantasia 社区' },
  'Wikiwiki': { Title: 'きらファン完全攻略 Wiki', Subtitle: '日语 Kirara Fantasia Wiki' },
  'Moegirl': { Title: '萌娘百科', Subtitle: '万物皆可萌的百科全书' },
  'Miraheze': { Title: 'Miraheze', Subtitle: '英语 Kirara Fantasia Wiki' },
  'Timers': { Title: '计时器', Subtitle: '活动日历与倒计时' },
};

const settings = {
  'Settings': '设定',

  'Character Show Max Status': '列表中显示最大数值',
  'Character Show Max Status Hint': '觉醒加成不包含在内',
  'Character Talent Show Luck': '显示天赋中的 LUK',
  'Character Icon Framed': '显示角色卡框',
  'Quest Drops Grouped': '掉落显示为「掉落数×组数」',
  'App Title Show ID': '标题栏中显示 ID',
  'Enemy AI Pattern': '显示敌人的 AI 行动模式',
  'Advanced Filter': '高级筛选',
  'Database': '数据库',
  'Database Fetch Time': '数据库获取时间',
  'Reload Database': '重新加载数据库',
  'Reload Application': '重新加载应用',
  'Language': '语言',
  'Always Show Japanese': '始终显示日语',
  'Package Fetch Time': '语言包获取时间',
  'Reload Language Package': '重新加载中文语言包',
  'Help Translate Names': '帮助我们翻译',

  'Show Clea On Start': '显示克蕾尔的 Live2D',
  'Show Clea On Start Hint': '可能会使用大量能耗',
  'Show Clea In Detail Page': '常驻显示',
  'Show Clea In Detail Page Hint': '克蕾尔酱超级可爱( ´▽｀)',

  'Application': '应用',
  'Contact': '联络',

  'Themes': {
    0: '红',
    1: '蓝',
    2: '橙',
    3: '绿',
    4: '紫',
    5: '黄',
    6: '粉',
    7: '动态主题',
  },

  'Close': '关闭',
  'Refresh': '刷新',
  'Updated': {
    'Database': '数据库更新完毕',
    'Application': '网页更新完毕',
  },
};

const clea = {
  'Clea': '克蕾尔',

  'Clea Conversation': {
    'TalkGroupA':
      [
        '元気が出ない時は、声を出すといいですよ。えいえい、おー！',
        'みなさんを召喚するために必要な\n『鍵』の管理を任せていただいています。',
        'ポルカとコルクちゃんは、\nわたしの大切なお友達です。',
        '元気が出ない時は、声を出すといいですよ。\nえいえい、おー！'
      ]
  }
};

module.exports = Object.assign({},
  common, home,
  chatacter, weapon, quest, enemy, master,
  item, roomObject, townObject,
  scenario, title, named,
  skill, help, navigation, settings,
  clea);
